import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@Components/Tooltip';
import { closeButtonId } from './InfoTooltipOnClickConstants';

import '../InfoTooltip.scss';

export default class InfoTooltipOnClick extends React.PureComponent {
  _closeButtonListener = () => {
    Tooltip.hide();
  };

  _afterShow = () => {
    const closeBtn = document.querySelector(`#${closeButtonId}`);
    if (closeBtn) closeBtn.addEventListener('click', this._closeButtonListener);
  };

  _afterHide = () => {
    const closeBtn = document.querySelector(`#${closeButtonId}`);
    if (closeBtn) closeBtn.removeEventListener('click', this._closeButtonListener);
  };

  render() {
    const { id, className, ...otherProps } = this.props;

    return (
      <Tooltip
        className={className}
        id={id}
        multiline
        html
        globalEventOff="click"
        clickable
        afterShow={this._afterShow}
        afterHide={this._afterHide}
        {...otherProps}
      />
    );
  }
}

InfoTooltipOnClick.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
};
